import * as auth from '../utils/auth'

const VueJwt = {}

VueJwt.install = function install(Vue) {
  if (install.installed) {
    return
  }
  install.installed = true

  Object.defineProperty(Vue.prototype, '$jwt', {
    get: auth.getUser,
  })
}

export default VueJwt



// WEBPACK FOOTER //
// ./client/plugins/jwt.js